import React, { useState, useRef } from 'react';
import { Input, TextArea, Form, Button, Modal, Dimmer, ModalContent, Checkbox } from 'semantic-ui-react';
import DropzoneComponent from './Dropzone';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { NumericFormat } from 'react-number-format';
import { SearchSKUAction, SaveUploadImgAction, SearchCodparcAction } from '../../../actions/EspacoTecaActions';
import styled from "styled-components";

const UploadPopup = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 24px 32px;
  border-radius: 12px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
  z-index: 9999; /* fica sempre acima */
  text-align: center;
  width: 300px;
`;

const Message = styled.p`
  font-size: 16px;
  margin-top: 12px;
  color: #333;
`;

const Loader = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: spin 1s linear infinite;
  margin: 0 auto;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;   /* garante cobertura total */
  height: 100vh;  /* garante cobertura total */
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
`;


function UploadImages(props) {
    const { SearchSKUAction, SaveUploadImgAction, SearchCodparcAction } = props; // actions
    const { isSearching, isSending, userid, isSearchingCodparc } = props; // reducers

    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [searchSKU, setSearchSKU] = useState('');
    const [codparcSearch, setCodparc] = useState("");
    const [nomeParc, setNomeParc] = useState("");
    const [isClienteAnom, setIsClienteAnom] = useState(false);
    const [codparcMessage, setCodparcMessage] = useState("");
    const [SKUName, setSKUName] = useState('');
    const [SKUMessage, setSKUMessage] = useState('');
    const [Observation, setObservation] = useState('');
    const [errorSaving, setErrorSaving] = useState([]);
    const [fileError, setFileError] = useState('');
    const [sucessMessage, setSucessMessage] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [totalSizeMB, setTotalSizeMB] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [progressText, setProgressText] = useState('')
    const [uploadCompleted, setUploadCompleted] = useState(false);
    const [showCompletion, setShowCompletion] = useState(false);
    // 🔑 ref para acessar função clearFiles do Dropzone
    const dropzoneRef = useRef();

    const handleSearchSKU = () => {
        if (searchSKU !== '') {
            SearchSKUAction(searchSKU).then((dados) => {
                setSKUName(dados[0].nomeprod ? dados[0].nomeprod : '');
                setSKUMessage(dados[0].message ? dados[0].message : '');
            });
        }
    };

    const handleSearchCodparc = () => {
        if (codparcSearch !== '') {
            const codparc = parseInt(codparcSearch);
            if (codparc !== 0) {
                SearchCodparcAction(codparc).then((dados) => {
                    console.log(dados)
                    setNomeParc(dados?.[0]?.nomeparc || '');
                    setCodparcMessage(dados?.[0]?.message || '');
                    setErrorSaving([]);
                });
            }
        }
    }

    const handleSend = () => {
        let listError = [];

        if (searchSKU === '') {
            listError.push({ sku: searchSKU, campo: 'sku' });
        }
        if (uploadedFiles.length === 0) {
            listError.push({ uploadedFiles: uploadedFiles, campo: 'uploadedFiles' });
            setFileError('Por favor, adicione ao menos um arquivo.');
        }

        setErrorSaving(listError);

        if (listError.length === 0) {
            // 🔹 calcula o tamanho total dos arquivos
            const totalSize = uploadedFiles.reduce((acc, file) => acc + file.size, 0);
            const totalMB = (totalSize / (1024 * 1024)).toFixed(2);
            setTotalSizeMB(totalMB);

            // se passar de 10MB, mostra aviso antes de continuar
            if (totalSize > 10 * 1024 * 1024) {
                setShowPopup(true);
                return;
            }

            // caso contrário, envia direto
            sendFiles();
        }
    };

    const sendFiles = () => {
        const data = {
            sku: searchSKU,
            userid: userid,
            codparc: codparcSearch,
            observation: Observation,
            files: uploadedFiles,
        };

        if (!isSending) {
            setIsUploading(true);

            // Passa callback para atualizar progresso
            setProgressText(`0/${uploadedFiles.length}`);
            SaveUploadImgAction(data, uploadedFiles, (completed, total) => {
                setProgressText(`${completed}/${total}`);
            }).then(() => {
                // Garante que o último 5/5 seja exibido
                setProgressText(`${uploadedFiles.length}/${uploadedFiles.length}`);

                // Delay curto antes de mostrar mensagem e GIF
                setTimeout(() => {
                    setUploadCompleted(true);  // marca como concluído
                    setShowCompletion(true);   // exibe GIF de forma suave

                    // Limpa outros estados
                    setSearchSKU('');
                    setSKUName('');
                    setSKUMessage('');
                    setObservation('');
                    setUploadedFiles([]);
                    setSucessMessage('');
                    setFileError('');
                    if (dropzoneRef.current) dropzoneRef.current.clearFiles();

                    // Fecha o pop-up após 2 segundos
                    setTimeout(() => {
                        setIsUploading(false);
                        setUploadCompleted(false);
                        setShowCompletion(false);
                        setProgressText('0/0'); // reinicia contador
                    }, 2000);
                }, 500); // 0.5s de delay para ver o 5/5
            });
        }
    };

    const handleNaoIdentificarCliente = (checked) => {
        setIsClienteAnom(checked);
        if (checked) {
            setCodparc('');
            setNomeParc('');
            setCodparcMessage('');
            setErrorSaving(prev => prev.filter(a => a.campo !== 'codparc'));
        }
    }

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '1rem',
                    marginTop: '1rem',
                }}
            >
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    <NumericFormat
                        placeholder="SKU"
                        name="sku"
                        customInput={Input}
                        control="input"
                        allowLeadingZeros={true}
                        value={searchSKU}
                        onBlur={handleSearchSKU}
                        onChange={(e) => setSearchSKU(e.target.value)}
                        error={errorSaving.some(a => a.campo === 'sku' && (!a.sku || a.sku === ''))}
                        loading={isSearching}
                    />
                    <p style={{ color: 'grey' }}>
                        {SKUName}
                    </p>
                </div>
            </div>
            {SKUMessage && <p style={{ color: 'red' }}>{SKUMessage}</p>}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                width: '500px',
            }}>

                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    <NumericFormat
                        placeholder="Parceiro"
                        name="sku"
                        customInput={Input}
                        control="input"
                        allowLeadingZeros={true}
                        value={codparcSearch}
                        onBlur={handleSearchCodparc}
                        onChange={(e) => setCodparc(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // evita submissão automática se estiver em form
                                handleSearchCodparc(e);
                            }
                        }}
                        error={errorSaving.some(a => a.campo === 'codparc' && (!a.codparc || a.codparc === ''))}
                        loading={isSearchingCodparc}
                        disabled={isClienteAnom}
                    />
                    <p style={{ color: 'grey' }}>
                        {nomeParc}
                    </p>
                </div>
                <div style={{ marginTop: '10px' }}>
                    <Checkbox
                        label="Não identificar cliente"
                        checked={isClienteAnom}
                        onChange={(e, { checked }) =>
                            handleNaoIdentificarCliente(checked)
                        }
                    />
                </div>
                <Form>
                    <p>Observações</p>
                    <TextArea
                        placeholder="Adicione observações sobre as imagens/videos carregados"
                        name="observacoes"
                        maxLength={3500}
                        style={{ resize: 'none' }}
                        value={Observation}
                        onChange={(e) => setObservation(e.target.value)}
                    />
                    <Form.Field
                        style={{ marginTop: '10px' }}
                        error={!!(errorSaving.uploadedFiles || fileError)}
                    >
                        <p>Upload de Imagem</p>
                        <DropzoneComponent
                            ref={dropzoneRef} // 🔑 passa ref aqui
                            maxFiles={5}
                            maxSize={5 * 1024 * 1024} // 5MB
                            accept={{
                                'image/png': ['.png'],
                                'image/jpeg': ['.jpeg'],
                                'image/jpg': ['.jpg'],
                                'video/mp4': ['.mp4'],
                                'video/quicktime': ['.mov'],
                            }}
                            onFilesChange={(files) => {
                                setUploadedFiles(files);
                                if (files.length === 0 && searchSKU !== '') {
                                    setFileError('Por favor, adicione ao menos um arquivo.');
                                } else {
                                    setFileError('');
                                }
                            }}
                            disabled={isSending}
                        />
                        {fileError !== '' && <p style={{ color: 'red' }}>{fileError}</p>}
                    </Form.Field>
                    {isSending && <p style={{ color: 'Blue' }}>Estamos enviando suas imagens, por favor aguarde.</p>}
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column'
                    }}>
                        <Button color="green"
                            onClick={handleSend}
                            loading={isSending}
                            disabled={SKUMessage !== '' ? true : false}
                            style={{ width: '300px' }}
                        >
                            Carregar Imagens
                        </Button>
                        {sucessMessage !== '' && <p style={{ color: 'green' }}>{sucessMessage}</p>}
                    </div>
                </Form>
            </div>

            {/* 🔹 Popup de aviso */}
            <Modal open={showPopup} size="small" onClose={() => setShowPopup(false)}>
                <Modal.Header>Aviso sobre o tamanho do upload</Modal.Header>
                <Modal.Content>
                    <p>
                        Notamos que seus arquivos somam <b>{totalSizeMB} MB</b>.
                        Por este motivo, o upload pode demorar um pouco.
                        <br /><br />
                        <b>Por favor, não feche ou recarregue esta tela até o envio ser concluído.</b>
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <Button color="green" onClick={() => {
                        setShowPopup(false);
                        sendFiles();
                    }}>
                        Entendi, pode enviar
                    </Button>
                </Modal.Actions>
            </Modal>
            {/* Popup de loading durante upload */}
            {isUploading && (
                <>

                    <Overlay />
                    <UploadPopup>
                        {!uploadCompleted ? (
                            <>
                                <Loader />
                                <Message>
                                    Estamos enviando seus arquivos,<br />
                                    não feche nem recarregue esta tela.
                                </Message>
                                <p>{progressText} arquivos enviados</p>
                                {/* Espaço reservado para evitar que o popup pule */}
                                {/* <div style={{ height: '152px' }} /> */}
                            </>
                        ) : (
                            // Sempre renderiza o container, só muda o conteúdo
                            <div
                                style={{
                                    height: '152px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'opacity 0.5s ease',
                                    opacity: showCompletion ? 1 : 0,
                                }}
                            >
                                <Message style={{ fontWeight: 'bold', color: 'green', fontSize: '18px' }}>
                                    Concluído!
                                </Message>
                                <img
                                    src="img/carregando-checked.gif"
                                    alt="Concluído"
                                    style={{ width: '80px', marginTop: '12px' }}
                                />
                                {/* <p>{progressText} arquivos enviados</p> */}
                            </div>
                        )}
                    </UploadPopup>


                </>

            )}




        </>
    );
}

const mapStateToProps = (state) => ({
    isSearching: state.EspacoTecaReducer.isSearching,
    isSending: state.EspacoTecaReducer.isSending,
    userid: state.LoginReducer.userid,
    isSearchingCodparc: state.EspacoTecaReducer.isSearchingCodparc,
});

export default withRouter(connect(mapStateToProps, {
    SearchSKUAction,
    SaveUploadImgAction,
    SearchCodparcAction
})(UploadImages));
